// extracted by mini-css-extract-plugin
export default {"modalBody":"SuccessModal_modalBody__vGtsa","headline":"SuccessModal_headline__tCNk-","successText":"SuccessModal_successText__ipn2y"};